import { useEffect, useRef, useState } from "react";

export default function StatsCounter({ stats }) {
  return (
    <section
      data-testid="stats-counter"
      className="bg-zinc-900 border-y border-zinc-800"
    >
      <div className="container-max py-16 grid grid-cols-2 lg:grid-cols-4 gap-y-10">
        {stats.map((s, i) => (
          <Stat key={s.label} value={s.value} label={s.label} delay={i * 90} />
        ))}
      </div>
    </section>
  );
}

function Stat({ value, label, delay = 0 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setTimeout(() => setVisible(true), delay);
            io.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [delay]);

  return (
    <div
      ref={ref}
      className={`px-6 lg:px-10 border-l border-zinc-800 transition-all duration-700 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
      }`}
    >
      <div className="font-display text-5xl sm:text-6xl text-zinc-50 tracking-wider">
        {value}
      </div>
      <div className="font-heading text-[11px] tracking-[0.3em] uppercase text-zinc-500 mt-2">
        {label}
      </div>
    </div>
  );
}
